import { render, staticRenderFns } from "./PaginatedListContainer.vue?vue&type=template&id=4a20abb4&scoped=true"
import script from "./PaginatedListContainer.vue?vue&type=script&lang=js"
export * from "./PaginatedListContainer.vue?vue&type=script&lang=js"
import style0 from "./PaginatedListContainer.vue?vue&type=style&index=0&id=4a20abb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a20abb4",
  null
  
)

export default component.exports